import { ResponseErrorsDto } from '../helperTypes/responseError';
import APIConfig from '../apiconfig';

export const redirectToLoginAppLogoutPage = () => {
  // Redirect to the new logout subdomain if users navigate to our subdomain for /logout
  const queryParams = window.location.search;
  const logoutRemainingPath = '/logout';

  window.location.href = `${APIConfig.login_host}${logoutRemainingPath}${queryParams}`;
};

export const redirectToLoginAppPage = () => {
  let redirect_to = '';
  const pathnameWithSearchParams =
    window.location.pathname + window.location.search;
  // Remove leading and trailing slashes from pathname so /login/identifier/ is same /login/identifier
  const pathname = window.location.pathname.replace(/^\/+|\/+$/g, '');
  const isLoginRoute = pathname === 'login' || pathname === 'login/identifier';
  if (!isLoginRoute && pathnameWithSearchParams) {
    redirect_to =
      '?redirect_to=' +
      encodeURIComponent(window.location.pathname + window.location.search);
  }
  window.location.href = `${APIConfig.login_host}/login/identifier${redirect_to}`;
};

export const shouldRedirectTo2faValidation = (
  errorResponseJson: ResponseErrorsDto,
  token?: string
) => {
  const validate2FARoute = `${process.env.publicPath}validate_2fa`;
  const currentRoute = window.location.pathname;
  const is2faValidationRoute = currentRoute === validate2FARoute;

  return Boolean(
    token &&
      errorResponseJson.errors &&
      errorResponseJson.errors.length > 0 &&
      errorResponseJson.errors[0].field === '2fa' &&
      !is2faValidationRoute
  );
};
